export default __webpack_public_path__ + "static/media/944.d5ad73a3.png";